export const ACCOUNT_MANAGE_ACCESS_CODES = Object.freeze({
  PAGE: 1000701,
  ADD_ACCOUNT: 1000701001,
  DELETE_ACCOUNT: 1000701002,
  EDIT_ACCOUNT: 1000701003,
  CREDIT_MANAGEMENT: 1000701004,
})

export function hasAccessPermission(disabledPermissions = [], accessCode) {
  if (accessCode === undefined || accessCode === null) {
    return true
  }

  if (!Array.isArray(disabledPermissions) || disabledPermissions.length === 0) {
    return true
  }

  return !disabledPermissions.includes(accessCode)
}
